import { render, staticRenderFns } from "./simLoginBuyPrice.vue?vue&type=template&id=e8112996&scoped=true&"
import script from "./simLoginBuyPrice.vue?vue&type=script&lang=js&"
export * from "./simLoginBuyPrice.vue?vue&type=script&lang=js&"
import style0 from "./simLoginBuyPrice.vue?vue&type=style&index=0&id=e8112996&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8112996",
  null
  
)

export default component.exports